export default __webpack_public_path__ + "static/media/bkg--interiors-3.040466cc.jpg";